module.exports = __webpack_public_path__ + "img/Unity_Logo_45x45.79e4961e.svg";